// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"134":"2da88e5c","187":"d293b529","270":"b8625c80","523":"2e32f4aa","927":"b946b556"}[chunkId] + ".css";
};